<template>
  <div id="app" class="app">
    <Header class="app__header" />
    <div class="content">
      <div class="content__inner">
        <router-view />
      </div>
    </div>
    <notifications
      group="main"
      position="bottom"
      width="100%"
      style="bottom: 1rem;"
      :duration="3000"
      class="notifcation-group"
      :reverse="true"
    >
      <template slot="body" slot-scope="props">
        <div class="notification" :class="`notification--${props.item.type}`" @click="props.close">
          <h1 class="notification__title">
            {{ props.item.title }}
          </h1>
          <p class="notification__text">{{ props.item.text }}</p>
        </div>
      </template>
    </notifications>
    <small class="app__version-info">v {{ version }} ({{ env }})</small>
    <ApplicationUpdate product="warehouse" env="production" />
  </div>
</template>

<script>
import Header from '@/components/Header'
import { env } from '@/shared/firebase'
import ApplicationUpdate from '@/shared/ApplicationUpdate'

export default {
  components: { Header, ApplicationUpdate },
  data() {
    return {
      env,
      version: process.env.VUE_APP_VERSION
    }
  }
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

html,
body {
  margin: 0;
  height: 100%;
  font-size: 16px;
}

@media (min-width: 480px) {
  html,
  body {
    font-size: 20px;
  }
}

.app {
  height: 100%;
  background: #fff;

  font-family: $font-family;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  &__header {
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 1;
  }

  &__version-info {
    display: block;
    text-align: center;
    font-size: 0.7rem;
  }
}

.view {
  display: flex;
  flex-direction: column;
  height: 100%;

  background: #fff;
}

.headline {
  margin: 2rem 1rem 1rem;
}

.header {
  flex-shrink: 0;
}

.content {
  flex-grow: 1;
  overflow-y: scroll;

  &__inner {
    margin: 0 auto;
    padding: 1rem 1rem 3rem;
    max-width: 50rem;
    width: 100%;
  }
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.notification {
  margin: 0.5rem auto;
  padding: 0.75rem 0.5rem 0.75rem 4rem;
  width: auto;
  max-width: 32rem;
  border-radius: 5px;
  cursor: pointer;

  &--scan-warning {
    background: $color-alert-yellow url(./scss/img/barcode-search.svg) 1rem center no-repeat;
    background-size: 2rem;
    color: #000;
  }

  &__title {
    margin: 0;

    font-size: 1.25rem;
  }
  &__text {
    margin: 0;

    font-size: 1rem;
  }
}

.blink {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>
